import React, { Component, Fragment } from 'react';
import { AvGroup, AvField } from 'availity-reactstrap-validation';
import i18n from '../../../../i18next';

import {
    MENU_ITEM_SUB_QUESTION,
    MENU_ITEM_TYPE_QUESTION,
    MENU_ITEM_SUB_ANSWER,
    MENU_ITEM_TYPE_ANSWER
} from '../../../../utils/Constants';

class MainInformation extends Component {
    renderNameInput() {
        return (
            <AvGroup>
                <AvField name="name" label={i18n.t('common:form.name')} type="text"
                    value={this.props.nameValue}
                    onChange={this.props.onChange}
                    required
                    errorMessage={i18n.t('common:validations.errorMsg')}
                    disabled={this.props.isDisabled ? this.props.isDisabled : false}/>
            </AvGroup>
        )
    }

    renderDescription() {
        const { descriptionStyle, inputCounter } = this.props.styles;

        return (
            <Fragment>
                <AvGroup hidden={this.hideDescriptionWhenQuestionOrAnswer()}>
                    <AvField
                        name="description" label={i18n.t('common:form.description')} type="textarea" id="description"
                        value={this.props.descriptionValue}
                        onChange={this.props.onChange} style={descriptionStyle}
                        maxLength={1024}
                        required={false} />
                </AvGroup>
                <div style={inputCounter}>{this.props.descriptionValue ? 1024 - this.props.descriptionValue.length : 1024} of 1024</div>
            </Fragment>
        )
    }

    hideDescriptionWhenQuestionOrAnswer() {
        const { itemType } = this.props;

        switch (itemType) {
            case MENU_ITEM_SUB_QUESTION:
            case MENU_ITEM_TYPE_QUESTION:
            case MENU_ITEM_TYPE_ANSWER:
            case MENU_ITEM_SUB_ANSWER:
                return true;
            default:
                return false;
        }
    }

    renderSelectDraft() {
        const { additionalTextInfo, textInfo } = this.props.styles;

        return (
            <AvGroup hidden={this.props.isDraftHidden}>
                <AvField type="select" name={`${this.props.draftName}`} id={`${this.props.draftName}`} label={`${this.props.labelText}`}
                    value={this.props.selectValue}
                    onChange={this.props.onChange}
                    disabled={this.props.isDraftDisabled}>
                    {this.renderReassignOptions(this.props.options)}
                </AvField>
                {
                    this.props.reassignInfoMsg &&
                    <div hidden={this.props.isMsgHidden} style={additionalTextInfo}>
                        <small style={textInfo}>{this.props.reassignInfoMsg}</small>
                    </div>
                }
            </AvGroup>
        )
    }

    renderAnswerGroup() {
        return (
            <AvGroup hidden={this.props.isSubAnswer}>
                <AvField type="select" name="answerGroup" label={i18n.t('screens:answerScreen.answerGroup')}
                    value={this.props.answerGroupValue}
                    onChange={this.props.onChange}
                >
                    <option id={-1} value={null}>{i18n.t('screens:answerScreen.defaultOption')}</option>
                    {this.renderAnswerGroups()}
                </AvField>
            </AvGroup>
        )
    }

    renderAnswerGroups() {
        if (this.props.answerGroups !== undefined) {
            return this.props.answerGroups.map((answerGroup, i) => {
                return (
                    <option key={`answerGroupOption${i}`} id={answerGroup.id} value={answerGroup.title}>{answerGroup.title}</option>
                );
            });
        }
    }

    renderReassignOptions(reassignOptions) {
        if (reassignOptions !== undefined && reassignOptions !== null && reassignOptions.length > 0) {
            return reassignOptions.map((option, i) => {
                return (
                    <option key={i} value={option.id}>{option.name}</option>
                );
            });
        }
    }

    render() {
        return (
            <Fragment>
                {this.renderNameInput()}
                {this.props.options && this.renderSelectDraft()}
                {this.props.answerGroups && this.renderAnswerGroup()}
                {this.props.descriptionValue !== undefined && this.renderDescription()}
            </Fragment>
        )
    }
}

export default MainInformation;


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/MainInformation.js